import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  PESSOAS_EDITAR_BEGIN,
  PESSOAS_EDITAR_SUCCESS,
  PESSOAS_EDITAR_FAILURE,
  PESSOAS_EDITAR_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function editar(registro, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: PESSOAS_EDITAR_BEGIN,
    data: registro,
    callback,
  };
}

export function dismissEditarError() {
  return {
    type: PESSOAS_EDITAR_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on PESSOAS_EDITAR_BEGIN actions
export function* doEditar(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const PessoaApi = new Services['PessoaApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield PessoaApi.patchOrCreate(action.data);
  } catch (err) {
    yield put({
      type: PESSOAS_EDITAR_FAILURE,
      data: { error: err },
    });

    if(action.callback){
      action.callback(PESSOAS_EDITAR_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: PESSOAS_EDITAR_SUCCESS,
    data: res,
  });

  if(action.callback){
    action.callback(PESSOAS_EDITAR_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchEditar() {
  yield takeLatest(PESSOAS_EDITAR_BEGIN, doEditar);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case PESSOAS_EDITAR_BEGIN:
      return {
        ...state,
        editarPending: true,
        editarError: null,
      };

    case PESSOAS_EDITAR_SUCCESS:
      return {
        ...state,
        registro: action.data,
        editarPending: false,
        editarError: null,
      };

    case PESSOAS_EDITAR_FAILURE:
      return {
        ...state,
        editarPending: false,
        editarError: action.data.error,
      };

    case PESSOAS_EDITAR_DISMISS_ERROR:
      return {
        ...state,
        editarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/pessoas/redux/editar.js